var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ManagerFilter, MobileCalendarFilter } from '../Calendar';
import { BodyTemplate, ColorTag, commonCssTypography, DrawerComponent, Icon, Marginer, MobileSmallCalendar, TextComponent, ClickableImage, useContentHeight, ClickableIcon, Rectangle, ScheduleDetailForModal, ScheduleBlock, NaverSmartPlaceCrawler, DoubleLineStoreOffTag, ReservationTable, CALENDER_GRID_TYPE, useNaverBlocking, CalendarFilterTooltip, AntConfirmWithSuccessIcon } from 'renderer/components';
import React from 'react';
import dayjs from 'dayjs';
import { Col, Row } from 'antd/lib/grid';
import { COLORS } from 'renderer/styles/colors';
import styled from 'styled-components';
import { Controller } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { bigCalendarLocalizer, bigCalenderFormats, getMinAndMaxHour, isEmpty, Lodash } from 'renderer/utils';
import { ScheduleQuery } from 'renderer/queries';
import { ScheduleModel } from 'renderer/models';
import useMeasure from 'react-use/lib/useMeasure';
import { Navigate, Route, Routes } from 'react-router';
import { DATE_FORMAT, PATH_APP_RESERVATION } from 'renderer/constants';
import { Calendar } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { IMAGES } from 'renderer/assets';
import Modal from 'antd/lib/modal';
import { typographyByName } from 'renderer/components';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Atoms } from 'renderer/stores';
import { DateRangeForReservationTable, TimeGutterHeader, TotalSalesComponent } from '../PCCalendar';
import DatePicker from 'antd/lib/date-picker';
import overlap from 'renderer/utils/dayLayoutAlgorithm';
import Dropdown from 'antd/lib/dropdown';
import Radio from 'antd/lib/radio';
import { scheduleCreateOrUpdate } from '../elements';
export var MobileCalendarContainer = function (props) {
    return props.store ? (React.createElement(Routes, null,
        React.createElement(Route, { path: "/", element: React.createElement(Navigate, { to: "".concat(PATH_APP_RESERVATION, "/week") }) }),
        React.createElement(Route, { path: "/week", element: React.createElement(MobileCalendar, __assign({}, props)) }))) : (React.createElement("div", null));
};
export var MobileCalendar = function (props) {
    var _a = useRecoilState(Atoms.calendarDisplaySelector), settings = _a[0], setSettings = _a[1];
    var managers = props.managers, currentDate = props.currentDate;
    var _b = React.useState(false), settingDrawerVisible = _b[0], setSettingDrawerVisible = _b[1];
    var _c = React.useState(settings === null || settings === void 0 ? void 0 : settings.view), mode = _c[0], setMode = _c[1];
    var _d = useRecoilState(Atoms.scheduleModalState), _ = _d[0], setScheduleModal = _d[1];
    var items = [
        { label: '일', key: CALENDER_GRID_TYPE.DAY },
        { label: '주', key: CALENDER_GRID_TYPE.WEEK },
        { label: '목록', key: CALENDER_GRID_TYPE.TABLE }
    ].map(function (item) {
        return {
            label: React.createElement(Radio, { checked: mode === item.key }, item.label),
            key: item.key,
            onClick: function () {
                setSettings(__assign(__assign({}, settings), { view: item.key }));
                setMode(item.key);
            }
        };
    });
    var _e = React.useState(false), openTooltip = _e[0], setOpenTooltip = _e[1];
    var getFilterActive = function () {
        var keys = ['types', 'deposits', 'status', 'managerIds'];
        return keys.some(function (key) {
            var _a;
            return ((_a = settings[key]) === null || _a === void 0 ? void 0 : _a.length) > 0;
        });
    };
    return (React.createElement(BodyTemplate, { title: '예약캘린더', content: React.createElement(Wrapper, null,
            React.createElement(Row, { align: "middle" },
                mode !== CALENDER_GRID_TYPE.TABLE && (React.createElement(StyledDateInput, { value: dayjs(currentDate), onChange: function (value) { return props.onCurrentDateChange(value.toDate()); }, suffixIcon: React.createElement(Icon, { name: "down-chevron", size: 24 }) })),
                React.createElement(Col, { flex: 1 }),
                React.createElement(NaverSmartPlaceCrawler, { store: props.store, currentDate: props.currentDate }),
                React.createElement("div", { style: { position: 'relative' } },
                    getFilterActive() && React.createElement(ActiveCircle, null),
                    React.createElement(CalendarFilterTooltip, { open: openTooltip && !settingDrawerVisible, onClose: function () {
                            setOpenTooltip(false);
                        } },
                        React.createElement(ClickableIcon, { style: { marginRight: '5px' }, size: 32, name: "filter", strokeWidth: 2, onClick: function () { return setSettingDrawerVisible(true); } }))),
                React.createElement(Dropdown, { menu: { items: items }, trigger: ['click'] },
                    React.createElement(ClickableImage, { src: mode === 'daily' || mode === CALENDER_GRID_TYPE.DAY
                            ? IMAGES.calendar_7days
                            : mode === 'weekly' || mode === CALENDER_GRID_TYPE.WEEK
                                ? IMAGES.calendar_week
                                : IMAGES.calendar_table })),
                React.createElement(AddScheduleButton, { onDrawerOpen: function () { return setScheduleModal({ type: 'create', schedule: {} }); } }),
                React.createElement(SettingDrawer, { onClose: function (values) {
                        console.log('values', values);
                        var keys = ['types', 'deposits', 'status', 'managerIds'];
                        var isOpen = keys.some(function (key) {
                            var _a;
                            return ((_a = values[key]) === null || _a === void 0 ? void 0 : _a.length) > 0;
                        });
                        setOpenTooltip(isOpen);
                        setSettingDrawerVisible(false);
                    }, visible: settingDrawerVisible, managers: managers })),
            mode === 'daily' || mode === CALENDER_GRID_TYPE.DAY ? (React.createElement(DailyMobileCalendar, __assign({}, props))) : mode === CALENDER_GRID_TYPE.TABLE ? (React.createElement(MobileReservationTable, __assign({}, props))) : (React.createElement(MobileWeeklyCalendar, __assign({ onChangeMode: function (mode) {
                    setMode(mode);
                } }, props)))) }));
};
var ActiveCircle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 3px;\n  right: 10px;\n  width: 10px;\n  height: 10px;\n  background-color: ", ";\n  border-radius: 50%;\n"], ["\n  position: absolute;\n  top: 3px;\n  right: 10px;\n  width: 10px;\n  height: 10px;\n  background-color: ", ";\n  border-radius: 50%;\n"])), COLORS.primary1);
var MobileReservationTable = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledDateRangeForReservationTable, { onSearchParamChange: props.onSearchParamChange, searchParams: props.searchParams, span: 16 }),
        React.createElement(ReservationTable, __assign({}, props))));
};
var StyledDateRangeForReservationTable = styled(DateRangeForReservationTable)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  flex-direction: column;\n"], ["\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  flex-direction: column;\n"])));
var StyledDateInput = styled(DatePicker).attrs({
    bored: false,
    // suffixIcon: null,
    format: 'YYYY년 MM월',
    inputReadOnly: true,
    allowClear: false
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  max-width: 150px;\n  &.ant-picker {\n    border: 0px solid #fff !important;\n  }\n  &.ant-picker:hover,\n  .ant-picker-focused {\n    border-color: #fff !important;\n    border-right-width: 0px !important;\n    box-shadow: 0 0 0 2px rgb(150 117 248 / 0%);\n  }\n  & input {\n    ", "\n    ", "\n  }\n  & svg {\n    color: black;\n    margin-top: 5px;\n  }\n"], ["\n  max-width: 150px;\n  &.ant-picker {\n    border: 0px solid #fff !important;\n  }\n  &.ant-picker:hover,\n  .ant-picker-focused {\n    border-color: #fff !important;\n    border-right-width: 0px !important;\n    box-shadow: 0 0 0 2px rgb(150 117 248 / 0%);\n  }\n  & input {\n    ", "\n    ", "\n  }\n  & svg {\n    color: black;\n    margin-top: 5px;\n  }\n"])), commonCssTypography, typographyByName('subtitle1'));
export var DailyMobileCalendar = function (props) {
    var _a, _b, _c, _d;
    var store = props.store, managers = props.managers, schedules = props.schedules, currentDate = props.currentDate, onCurrentDateChange = props.onCurrentDateChange;
    var timestep = (store === null || store === void 0 ? void 0 : store.operationPreference.timeStep) || 30;
    var _e = React.useState([]), slides = _e[0], setSlides = _e[1];
    var _f = useRecoilState(Atoms.scheduleModalState), _ = _f[0], setScheduleModal = _f[1];
    React.useEffect(function () {
        var startOfWeek = dayjs(currentDate).startOf('week');
        setSlides([
            { startDate: startOfWeek.subtract(1, 'week').startOf('week') },
            { startDate: startOfWeek },
            { startDate: startOfWeek.add(1, 'week').startOf('week') }
        ]);
    }, [currentDate]);
    var handleClickSlot = function (date, managerId) {
        setScheduleModal({
            type: 'create',
            schedule: {
                managerId: managerId,
                dateOption: { startedAt: dayjs(date).toDate(), endedAt: dayjs(date).add(timestep, 'minute').toDate() }
            }
        });
    };
    var convertToEvent = function (item) { return ({
        title: item.displayName,
        start: dayjs(item.dateOption.startedAt).isSame(currentDate, 'day')
            ? dayjs(item.dateOption.startedAt).toDate()
            : dayjs("".concat(dayjs(currentDate).format('YYYY-MM-DD'), " 00:00")).toDate(),
        end: dayjs(item.dateOption.endedAt).isSame(currentDate, 'day')
            ? dayjs(item.dateOption.endedAt).toDate()
            : dayjs("".concat(dayjs(currentDate).format('YYYY-MM-DD'), " 23:59")).toDate(),
        resourceId: item.managerId || -1,
        schedule: item
    }); };
    var todaySchedules = schedules.filter(function (item) { return item.isInDateStartAndEnd(currentDate); });
    var events = todaySchedules.map(convertToEvent);
    var _g = React.useState(), selectedSchedule = _g[0], setSelectedSchedule = _g[1];
    var settings = useRecoilValue(Atoms.calendarDisplaySelector);
    var shownManagerIds = settings.managerIds || [];
    var todayOffList = ((_a = props.offList) === null || _a === void 0 ? void 0 : _a.filter(function (off) { return off.isInDateStartAndEnd(currentDate); })) || [];
    var visibleSale = ((_b = store === null || store === void 0 ? void 0 : store.operationPreference) === null || _b === void 0 ? void 0 : _b.saleDisplay) !== 'hide';
    var resources = (_d = (_c = managers === null || managers === void 0 ? void 0 : managers.concat({
        id: -1,
        displayName: '담당자 없음',
        date: currentDate,
        visibleSale: visibleSale,
        count: Lodash.sum(events.map(function (event) { return (event.resourceId === -1 ? 1 : 0); })),
        total: ScheduleQuery.getSalesStatFromCache(currentDate)
    })) === null || _c === void 0 ? void 0 : _c.filter(function (manager) { return isEmpty(shownManagerIds) || shownManagerIds.includes(manager.id); })) === null || _d === void 0 ? void 0 : _d.map(function (item) {
        return ({
            id: item.id,
            name: item.displayName,
            date: currentDate,
            visibleSale: visibleSale,
            off: todayOffList === null || todayOffList === void 0 ? void 0 : todayOffList.find(function (off) { return off.managerId === item.id; }),
            count: Lodash.sum(events.map(function (event) { return (event.resourceId === item.id ? 1 : 0); })),
            total: ScheduleQuery.getSalesStatFromCache(currentDate, item.id),
            onClickOff: function (off) { return setSelectedSchedule(off); }
        });
    });
    var _h = getMinAndMaxHour(store, todaySchedules, true), min = _h.min, max = _h.max;
    var headerHeight = useRecoilValue(Atoms.globalHeaderHeightState);
    var calenderHeader = 54 + 30;
    var contentHeight = useContentHeight(false, false) - calenderHeader;
    var storeOff = todayOffList === null || todayOffList === void 0 ? void 0 : todayOffList.find(function (item) { return !item.managerId; });
    var createSchedule = ScheduleQuery.useCreateSchedule();
    // TODO: 여기를 막자!!
    var updateSchedule = ScheduleQuery.useUpdateSchedule();
    var createNewRepeatSchedule = ScheduleQuery.useCreateNewRepeatSchedule();
    var naverStatusHook = useNaverBlocking();
    var activeScheduleBlockSettings = props.store.activeScheduleBlockSettings;
    var handleSelect = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var start, end, resourceId, confirmInstance_1;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    start = params.start, end = params.end, resourceId = params.resourceId;
                    if (!(params.action === 'select')) return [3 /*break*/, 3];
                    if (((_b = (_a = store.preference) === null || _a === void 0 ? void 0 : _a.operation) === null || _b === void 0 ? void 0 : _b.simpleScheduleCreate) === 'inactive') {
                        return [2 /*return*/];
                    }
                    if (!(!((_d = (_c = store.preference) === null || _c === void 0 ? void 0 : _c.operation) === null || _d === void 0 ? void 0 : _d.simpleScheduleCreate) ||
                        ((_f = (_e = store.preference) === null || _e === void 0 ? void 0 : _e.operation) === null || _f === void 0 ? void 0 : _f.simpleScheduleCreate) === 'active')) return [3 /*break*/, 2];
                    return [4 /*yield*/, scheduleCreateOrUpdate({
                            storeId: props.store.id,
                            managerId: resourceId,
                            name: '간단일정',
                            dateOption: {
                                type: 'once',
                                startedAt: start,
                                endedAt: end
                            },
                            status: ScheduleModel.RESERVATION_STATUS.CONFIRMED,
                            from: ScheduleModel.RESERVATION_FROM.CRM,
                            type: ScheduleModel.RESERVATION_TYPE.SCHEDULE
                        }, {}, props.store, createSchedule, updateSchedule, createNewRepeatSchedule, false, naverStatusHook)];
                case 1: return [2 /*return*/, _g.sent()];
                case 2:
                    confirmInstance_1 = AntConfirmWithSuccessIcon({
                        type: 'success',
                        title: '간단일정',
                        content: '일정을 추가합니다.',
                        centered: true,
                        cancelButtonProps: {
                            children: '취소',
                            onClick: function () {
                                confirmInstance_1.destroy();
                            }
                        },
                        okButtonProps: {
                            children: '확인',
                            onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, scheduleCreateOrUpdate({
                                                storeId: props.store.id,
                                                managerId: resourceId,
                                                name: '간단일정',
                                                dateOption: {
                                                    type: 'once',
                                                    startedAt: start,
                                                    endedAt: end
                                                },
                                                status: ScheduleModel.RESERVATION_STATUS.CONFIRMED,
                                                from: ScheduleModel.RESERVATION_FROM.CRM,
                                                type: ScheduleModel.RESERVATION_TYPE.SCHEDULE
                                            }, {}, props.store, createSchedule, updateSchedule, createNewRepeatSchedule, false, naverStatusHook)];
                                        case 1:
                                            _a.sent();
                                            confirmInstance_1.destroy();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }
                    });
                    _g.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(DayViewWrapper, null,
        storeOff && (React.createElement(DoubleLineStoreOffTag, { "$headerHeight": headerHeight + calenderHeader, onClick: function () { return setSelectedSchedule(storeOff); }, children: "\uC0C1\uC810" })),
        React.createElement(InfiniteSwiperWithDate, { isNotFullHeight: true, threshold: 100, currentDate: currentDate, onCurrentDateChange: onCurrentDateChange, renderSlide: function (slide, index) {
                return (React.createElement(DayViewDateController, { key: "".concat(dayjs(slide.startDate).format(), "_").concat(index) }, Lodash.times(7).map(function (_, index) {
                    var targetDate = slide.startDate.add(index, 'day');
                    var isHoliday = ScheduleQuery.getHolidayInfo(targetDate.toDate());
                    var opacity = targetDate.isSame(currentDate, 'day') ? 1 : 0.2;
                    var isSaturday = targetDate.day() === 6;
                    var color = isHoliday ? COLORS.calendarRedActive : isSaturday ? COLORS.info : COLORS.black;
                    return (React.createElement("div", { key: "".concat(targetDate.format(), "_").concat(index), onClick: function () { return onCurrentDateChange(targetDate.toDate()); }, style: {
                            flex: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexDirection: 'column',
                            opacity: opacity
                        } },
                        React.createElement(TextComponent, { color: color }, targetDate.format('ddd')),
                        React.createElement(TextComponent, { color: color }, targetDate.format('MM.DD'))));
                })));
            } }),
        React.createElement(StyledDailyCalendar, { showMultiDayTimes: true, height: contentHeight, timeslots: timestep === 30 ? 2 : 6, date: currentDate, step: timestep, selectable: true, onSelectSlot: handleSelect, slotPropGetter: function (date, resourceId) { return ({
                onClick: function () { return handleClickSlot(date, Number(resourceId)); },
                style: {
                    zIndex: 1,
                    backgroundColor: !store.isStoreOperatingHour(dayjs(date)) ? COLORS.gray8 : COLORS.white
                }
            }); }, scrollToTime: min, eventPropGetter: function (event) {
                return {
                    style: {
                        zIndex: 2,
                        padding: 0,
                        backgroundColor: '#fff',
                        border: '0px solid black'
                    }
                };
            }, 
            // scrollToTime={selectedSchedule ? dayjs(selectedSchedule.dateOption.startedAt).toDate() : dayjs().toDate()}
            components: {
                timeSlotWrapper: function (item, idx) {
                    var _a;
                    var shouldShowTime = dayjs(item.value).minute() === 0 ||
                        (((_a = store.operationPreference) === null || _a === void 0 ? void 0 : _a.timeStepInMobile) !== 60 && dayjs(item.value).minute() === 30);
                    return item.resource ? (item.children) : !shouldShowTime ? (React.createElement("div", { className: 'rbc-time-slot', key: idx })) : (React.createElement("div", { className: 'rbc-time-slot', key: idx },
                        React.createElement(TextComponent, { children: dayjs(item.value).format('a hh:mm'), type: "body6", marginLeft: 3, marginRight: 3 })));
                },
                event: function (_a) {
                    var event = _a.event;
                    return (React.createElement(ScheduleBlock, { schedule: event.schedule, key: event.schedule.id, disablePopover: true, blockSettings: activeScheduleBlockSettings }));
                },
                toolbar: null,
                agenda: {
                    event: null // with the agenda view use a different component to render events
                },
                timeGutterHeader: visibleSale && MobileTimeGutterHeader
            }, onSelectEvent: function (data, event) {
                event.stopPropagation();
                event.preventDefault();
                setSelectedSchedule(data.schedule);
            }, events: events, min: min, max: max, longPressThreshold: 800, resources: resources, resourceTitleAccessor: ResourceItem, dayLayoutAlgorithm: function (params) {
                // [NO.719]주캘린더에서 예약이 가려져 안보여요. 해결하기 위해 넣음 함수 자체 제작
                // [NO.710]모바일 캘린더 정렬이 안 맞음를 해결하기 위해 넣음
                return overlap(__assign(__assign({}, params), { minimumStartDifference: timestep }));
            } }),
        React.createElement(TodayButton, { onClick: function () { return props.onCurrentDateChange(new Date()); } }),
        selectedSchedule && (React.createElement(ReservationInfoModal, { store: props.store, data: selectedSchedule, onClose: function () { return setSelectedSchedule(undefined); } }))));
};
var MobileTimeGutterHeader = styled(TimeGutterHeader)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  & > .off {\n    height: 22px;\n  }\n  & > .sales {\n    height: 22px;\n    padding-left: 0px;\n    width: 56px;\n    position: absolute;\n    top: -22px;\n    z-index: 99999;\n    left: -5px;\n}\n  }\n"], ["\n  & > .off {\n    height: 22px;\n  }\n  & > .sales {\n    height: 22px;\n    padding-left: 0px;\n    width: 56px;\n    position: absolute;\n    top: -22px;\n    z-index: 99999;\n    left: -5px;\n}\n  }\n"])));
var ResourceItem = function (props) {
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%'
        } },
        React.createElement(Row, { style: {
                width: '100%',
                borderBottom: "1px solid ".concat(COLORS.gray6),
                height: !props.visibleSale ? '100%' : '28px'
            }, wrap: false, align: "middle" },
            props.off ? (React.createElement(ColorTag, { children: "\uD734\uBB34", color: COLORS.gray1, onClick: function () { return props.onClickOff(props.off); }, style: { fontSize: '12px', marginLeft: '5px' } })) : props.count ? (React.createElement(Col, null,
                React.createElement(ColorTag, { style: { fontSize: '12px', marginLeft: '5px' }, color: COLORS.primary3, children: props.count }))) : (React.createElement(Col, { span: 0 })),
            React.createElement(Col, { flex: 1 },
                React.createElement(TextComponent, { key: props.id, ellipsis: true, style: { width: '100%', paddingLeft: '5px' } }, props.name))),
        props.visibleSale && (React.createElement(Row, { style: { height: '22px', width: '55px' }, wrap: false },
            React.createElement(TotalSalesComponent, { date: props.date, total: props.total })))));
};
var DayViewWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  height: 100%;\n  overflow: hidden;\n"], ["\n  height: 100%;\n  overflow: hidden;\n"])));
var DayViewDateController = styled(Row)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  height: 54px;\n  width: 100%;\n  border-top: solid 1px var(--gray-6);\n"], ["\n  height: 54px;\n  width: 100%;\n  border-top: solid 1px var(--gray-6);\n"])));
export var MobileWeeklyCalendar = function (props) {
    var store = props.store, schedules = props.schedules, currentDate = props.currentDate, onCurrentDateChange = props.onCurrentDateChange;
    return (React.createElement(React.Fragment, null,
        React.createElement(InfiniteSwiperWithDate, { currentDate: currentDate, onCurrentDateChange: onCurrentDateChange, renderSlide: function (slide) {
                return (React.createElement(MobileWeek, { key: dayjs(slide.startDate).format(DATE_FORMAT), onClickDate: function (date) {
                        onCurrentDateChange(date.toDate());
                        props.onChangeMode(CALENDER_GRID_TYPE.DAY);
                    }, offList: props.offList, store: store, schedules: schedules, startDate: slide.startDate, currentDate: currentDate, onCurrentDateChange: onCurrentDateChange }));
            } }),
        React.createElement(TodayButton, { onClick: function () { return props.onCurrentDateChange(new Date()); } })));
};
var AddScheduleButton = function (props) {
    return (React.createElement(ClickableIcon, { onClick: props.onDrawerOpen, strokeWidth: 2, name: "plus", size: 32, style: { marginRight: '5px' } }));
};
var TodayButton = styled.div.attrs({
    children: (React.createElement(Row, { align: "middle", justify: "center" },
        React.createElement(Icon, { name: "left-chevron", color: COLORS.gray4 }),
        React.createElement(TextComponent, { children: "\uC624\uB298", type: "body6" })))
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 20px;\n  left: calc(50% - 28px);\n  width: 56px;\n  height: 28px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 0 5px 0 var(--primary-shadow);\n  border: solid 1px var(--gray-6);\n  background-color: var(--white);\n  z-index: 3;\n"], ["\n  position: absolute;\n  bottom: 20px;\n  left: calc(50% - 28px);\n  width: 56px;\n  height: 28px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 0 5px 0 var(--primary-shadow);\n  border: solid 1px var(--gray-6);\n  background-color: var(--white);\n  z-index: 3;\n"])));
var MobileWeek = function (props) {
    var today = dayjs();
    var elements = [{ type: 'calendar' }].concat(Lodash.times(7).map(function (index) { return ({ date: props.startDate.add(index, 'day') }); }));
    var _a = useMeasure(), ref = _a[0], height = _a[1].height;
    var hideBanner = useRecoilValue(Atoms.hideStickBannerState);
    var scheduleWrapperHeight = ((height || 600) - (hideBanner ? 40 : 0)) / 4 - 65;
    var activeScheduleBlockSettings = props.store.activeScheduleBlockSettings;
    var countOfShownSchedules = Lodash.floor(scheduleWrapperHeight / 22);
    return (React.createElement(MobileWeekWrapper, { ref: ref, hideBanner: hideBanner },
        React.createElement(Row, null, elements.map(function (element, index) {
            var _a, _b, _c, _d;
            var targetDate = element.date;
            var holiday = targetDate && ScheduleQuery.getHolidayInfo(targetDate === null || targetDate === void 0 ? void 0 : targetDate.toDate());
            var schedules = targetDate ? (_a = props.schedules) === null || _a === void 0 ? void 0 : _a.filter(function (item) { return item.isInDateStartAndEnd(targetDate); }) : [];
            var offList = targetDate
                ? (_b = props.offList) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item.managerId && item.isInDateStartAndEnd(targetDate); })
                : [];
            var storeOff = targetDate && ((_c = props.offList) === null || _c === void 0 ? void 0 : _c.find(function (item) { return !item.managerId && item.isInDateStartAndEnd(targetDate); }));
            var countOfNoneSchedules = ((schedules === null || schedules === void 0 ? void 0 : schedules.length) || 0) - (countOfShownSchedules || 0);
            var isToday = today.isSame(targetDate, 'day');
            var isSaturday = dayjs(targetDate).day() === 6;
            var total = ScheduleQuery.getSalesStatFromCache(targetDate);
            return element.type ? (React.createElement(WeekItemWrapper, { key: "".concat(index) },
                React.createElement(MobileSmallCalendar, { targetDate: dayjs(props.currentDate), onDateChange: props.onCurrentDateChange }))) : (React.createElement(WeekItemWrapper, { key: dayjs(targetDate).format(DATE_FORMAT), onClick: function () { return props.onClickDate(element.date); }, "$isToday": isToday },
                React.createElement(Row, { justify: "space-between", align: "middle", wrap: true },
                    React.createElement(TextComponent, { type: "body3", children: (_d = element.date) === null || _d === void 0 ? void 0 : _d.format('DD. dd'), color: !!holiday ? COLORS.calendarRedActive : isSaturday ? COLORS.info : COLORS.black }),
                    isEmpty(offList) ? (typeof holiday === 'string' && (React.createElement(TextComponent, { type: "body3", children: holiday, color: COLORS.calendarRedActive }))) : (React.createElement(Row, { align: "middle" },
                        storeOff && React.createElement(ColorTag, { color: COLORS.gray1, children: "\uC0C1\uC810\uD734\uBB34" }),
                        offList.map(function (off) {
                            var _a;
                            return (React.createElement(Rectangle, { width: 12, color: (_a = off.color) === null || _a === void 0 ? void 0 : _a.manager, key: off.id, style: { marginRight: '3px' } }));
                        })))),
                React.createElement(SchedulesWrapper, null, schedules === null || schedules === void 0 ? void 0 : schedules.map(function (schedule, index) {
                    return index < countOfShownSchedules ? (React.createElement(ScheduleBlock, { showTime: true, disablePopover: true, schedule: schedule, key: schedule.id, blockSettings: activeScheduleBlockSettings })) : null;
                })),
                countOfNoneSchedules > 0 ? (React.createElement(Row, { style: { width: '100%' }, wrap: false, align: "middle", justify: "space-between" },
                    React.createElement(TextComponent, { marginTop: 5, marginBottom: 5, type: "body6", color: COLORS.gray2, children: "+ ".concat(countOfNoneSchedules, "\uAC74") }),
                    React.createElement(TotalSalesComponent, { date: targetDate, total: total }))) : (React.createElement(Row, { style: { width: '100%' }, wrap: false, align: "middle", justify: "space-between" },
                    React.createElement(TextComponent, { marginTop: 5, marginBottom: 5, type: "body6", color: COLORS.white, children: "0" }),
                    React.createElement(TotalSalesComponent, { date: targetDate, total: total })))));
        }))));
};
var InfiniteSwiperWithDate = function (props) {
    var isNotFullHeight = props.isNotFullHeight, onCurrentDateChange = props.onCurrentDateChange, currentDate = props.currentDate;
    var _a = React.useState([]), slides = _a[0], setSlides = _a[1];
    var _b = React.useState(), controlledController = _b[0], setController = _b[1];
    React.useEffect(function () {
        var startWeek = dayjs(currentDate).startOf('week');
        setSlides([
            { startDate: startWeek.subtract(1, 'week') },
            { startDate: startWeek },
            { startDate: startWeek.add(1, 'week') }
        ]);
        if (controlledController) {
            controlledController.slideTo(1, 0);
        }
    }, [currentDate]);
    return (React.createElement(Swiper, { observer: true, modules: [Controller], onSwiper: function (swiper) { return setController(swiper); }, threshold: 15, initialSlide: 1, onSlideChange: function (swiper) {
            var previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex;
            if ((previousIndex === 0 && activeIndex === 1) || (previousIndex === 2 && activeIndex === 1)) {
                return;
            }
            var activeSlide = slides[activeIndex];
            if (activeSlide) {
                var startDate = dayjs(activeSlide.startDate);
                var currentDate_1 = dayjs(props.currentDate);
                onCurrentDateChange(startDate.isAfter(currentDate_1)
                    ? dayjs(currentDate_1).add(1, 'week').toDate()
                    : dayjs(currentDate_1).subtract(1, 'week').toDate());
            }
        }, style: !isNotFullHeight ? { height: '100%', width: '100%' } : { width: '100%' } }, slides.map(function (item, index) {
        return (React.createElement(SwiperSlide, { key: "".concat(item.startDate.format(DATE_FORMAT), "_").concat(index) }, props.renderSlide(item, index)));
    })));
};
var MobileWeekWrapper = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  width: 100%;\n  height: calc(100% - ", "px);\n  & > .ant-row {\n    height: 100%;\n  }\n"], ["\n  width: 100%;\n  height: calc(100% - ", "px);\n  & > .ant-row {\n    height: 100%;\n  }\n"])), function (props) { return (props.hideBanner ? 0 : 40); });
var WeekItemWrapper = styled(Col).attrs({ span: 12 })(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  padding: 10px;\n  height: 25%;\n  display: flex;\n  flex-direction: column;\n\n  border-top: solid 1px var(--gray-6);\n  ", "\n\n  ", "\n"], ["\n  padding: 10px;\n  height: 25%;\n  display: flex;\n  flex-direction: column;\n\n  border-top: solid 1px var(--gray-6);\n  ", "\n\n  ", "\n"])), function (props) {
    return !props.$isToday &&
        "\n    &:nth-child(2n) {\n      border-left: solid 1px var(--gray-6);\n    }\n  ";
}, function (props) {
    return props.$isToday &&
        "\n    border: solid 1px var(--primary-1);\n  ";
});
var SchedulesWrapper = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  margin-top: 5px;\n  flex: 1;\n"], ["\n  margin-top: 5px;\n  flex: 1;\n"])));
var SettingDrawer = function (props) {
    var _a = useRecoilState(Atoms.calendarDisplaySelector), settings = _a[0], setSettings = _a[1];
    var shownManagerIds = (settings === null || settings === void 0 ? void 0 : settings.managerIds) || [];
    return (React.createElement(DrawerComponent, { open: props.visible, onClose: function () { return props.onClose(settings); }, title: "\uCE98\uB9B0\uB354 \uC124\uC815", children: React.createElement(React.Fragment, null,
            React.createElement(ManagerFilter, { onChange: function (managerIds) {
                    setSettings(__assign(__assign({}, settings), { managerIds: managerIds }));
                }, shownManagerIds: shownManagerIds, managers: props.managers, isMobile: true }),
            React.createElement(Marginer, { height: 20 }),
            React.createElement(MobileCalendarFilter, { filters: [
                    {
                        label: '예약',
                        value: ScheduleModel.RESERVATION_TYPE.RESERVATION,
                        items: [
                            { label: '예약대기', value: ScheduleModel.RESERVATION_STATUS.PENDING },
                            { label: '예약확정', value: ScheduleModel.RESERVATION_STATUS.CONFIRMED },
                            { label: '예약확정', value: ScheduleModel.RESERVATION_STATUS.COMPLETED },
                            { label: '매출등록', value: 'sales' },
                            { label: '노쇼', value: ScheduleModel.RESERVATION_STATUS.NOSHOW },
                            { label: '상점취소', value: ScheduleModel.RESERVATION_STATUS.CANCELLED_STORE },
                            { label: '고객취소', value: ScheduleModel.RESERVATION_STATUS.CANCELLED_CUSTOMR }
                        ]
                    },
                    {
                        value: ScheduleModel.RESERVATION_TYPE.SCHEDULE,
                        label: '일정'
                    },
                    {
                        value: ScheduleModel.RESERVATION_TYPE.OFF,
                        label: '휴무'
                    }
                ], title: '스케쥴', onChange: function (newData) {
                    setSettings(__assign(__assign({}, settings), { types: newData }));
                }, data: settings.types }),
            React.createElement(Marginer, { height: 20 }),
            React.createElement(MobileCalendarFilter, { filters: [
                    {
                        value: ScheduleModel.RESERVATION_FROM.NAVER,
                        label: '네이버',
                        icon: IMAGES.schedule_icon_naver
                    },
                    {
                        value: ScheduleModel.RESERVATION_FROM.CRM,
                        label: '직접등록',
                        icon: IMAGES.schedule_icon_thinkofyou
                    }
                ], title: '등록경로', onChange: function (newData) {
                    setSettings(__assign(__assign({}, settings), { provider: newData }));
                }, data: settings.provider }),
            React.createElement(Marginer, { height: 20 }),
            React.createElement(MobileCalendarFilter, { filters: [
                    {
                        value: 'none',
                        label: '예약금 없음'
                    },
                    {
                        value: 'pending',
                        label: '예약금 있음 - 입금대기',
                        icon: IMAGES.schedule_icon_deposit_pending
                    },
                    {
                        value: 'completed',
                        label: '예약금 있음 - 입금완료',
                        icon: IMAGES.schedule_icon_deposit_complete
                    },
                    {
                        value: 'over',
                        label: '예약금 있음 - 입금초과',
                        icon: IMAGES.schedule_icon_deposit_over
                    },
                    {
                        value: 'under',
                        label: '예약금 있음 - 입금부족',
                        icon: IMAGES.schedule_icon_deposit_under
                    }
                ], title: '예약금', onChange: function (newData) {
                    setSettings(__assign(__assign({}, settings), { deposits: newData }));
                }, data: settings.deposits })) }));
};
var ReservationInfoModal = function (props) {
    var data = props.data;
    return (React.createElement(StyledModal, { centered: true, footer: null, closable: false, visible: !!data, onCancel: props.onClose },
        React.createElement(ScheduleDetailForModal, { schedule: data, onCloseModal: props.onClose })));
};
var StyledModal = styled(Modal)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  & .ant-modal-body {\n    padding: 0 !important;\n  }\n\n  & .ant-modal-content {\n    border-radius: 4px;\n    border: solid 1px var(--gray-6);\n    position: relative;\n    background-color: #fff;\n    background-clip: padding-box;\n    box-shadow: 0 0px 0px 0px rgb(0 0 0 / 12%), 0 0px 0px 0px rgb(0 0 0 / 8%), 0 0px 0px 0px rgb(0 0 0 / 5%);\n    pointer-events: auto;\n    padding: 10px;\n  }\n"], ["\n  & .ant-modal-body {\n    padding: 0 !important;\n  }\n\n  & .ant-modal-content {\n    border-radius: 4px;\n    border: solid 1px var(--gray-6);\n    position: relative;\n    background-color: #fff;\n    background-clip: padding-box;\n    box-shadow: 0 0px 0px 0px rgb(0 0 0 / 12%), 0 0px 0px 0px rgb(0 0 0 / 8%), 0 0px 0px 0px rgb(0 0 0 / 5%);\n    pointer-events: auto;\n    padding: 10px;\n  }\n"])));
var StyledDailyCalendar = styled(Calendar).attrs({
    localizer: bigCalendarLocalizer,
    formats: bigCalenderFormats,
    startAccessor: 'start',
    endAccessor: 'end',
    toolbar: false,
    tooltipAccessor: null,
    titleAccessor: null,
    allDayAccessor: null,
    view: 'day'
})(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  height: ", "px !important;\n  & .rbc-time-header-content {\n    border-left: 0px;\n    border-right: 1px solid ", ";\n  }\n\n  /* mobile react-big-calendar */\n  & .rbc-timeslot-group {\n    height: 90px;\n    min-height: 90px !important;\n    background-color: white;\n  }\n  & .rbc-time-view-resources .rbc-header {\n    height: 50px;\n  }\n  & .rbc-time-header-content > .rbc-row.rbc-row-resource {\n    border-bottom: 0px solid #ddd !important;\n  }\n\n  & .rbc-time-content {\n    border-top: 1px solid ", ";\n  }\n\n  & .rbc-time-header {\n    background-color: ", ";\n    & > .rbc-time-header-gutter {\n      background-color: ", ";\n    }\n  }\n  & .rbc-header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-bottom: 0px solid #ddd !important;\n    flex-direction: column;\n    padding: 0px;\n  }\n  .rbc-time-gutter.rbc-time-column {\n    & > .rbc-timeslot-group {\n      background-color: ", ";\n    }\n  }\n  /* hide allday */\n  & .rbc-allday-cell {\n    display: none;\n  }\n  /* hide time in event */\n  & .rbc-event-label {\n    display: none !important;\n  }\n  & .rbc-time-header-gutter {\n    border-right: 1px solid ", ";\n  }\n  & .rbc-timeslot-group > .rbc-time-slot:nth-child(", ") {\n    border-top: 1px ", " solid !important;\n  }\n  & .rbc-day-slot .rbc-time-slot {\n    border-top: 1px ", " solid !important;\n  }\n  & .rbc-day-slot .rbc-event,\n  .rbc-day-slot .rbc-background-event {\n    min-height: 15px !important;\n  }\n"], ["\n  height: ", "px !important;\n  & .rbc-time-header-content {\n    border-left: 0px;\n    border-right: 1px solid ", ";\n  }\n\n  /* mobile react-big-calendar */\n  & .rbc-timeslot-group {\n    height: 90px;\n    min-height: 90px !important;\n    background-color: white;\n  }\n  & .rbc-time-view-resources .rbc-header {\n    height: 50px;\n  }\n  & .rbc-time-header-content > .rbc-row.rbc-row-resource {\n    border-bottom: 0px solid #ddd !important;\n  }\n\n  & .rbc-time-content {\n    border-top: 1px solid ", ";\n  }\n\n  & .rbc-time-header {\n    background-color: ", ";\n    & > .rbc-time-header-gutter {\n      background-color: ", ";\n    }\n  }\n  & .rbc-header {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-bottom: 0px solid #ddd !important;\n    flex-direction: column;\n    padding: 0px;\n  }\n  .rbc-time-gutter.rbc-time-column {\n    & > .rbc-timeslot-group {\n      background-color: ", ";\n    }\n  }\n  /* hide allday */\n  & .rbc-allday-cell {\n    display: none;\n  }\n  /* hide time in event */\n  & .rbc-event-label {\n    display: none !important;\n  }\n  & .rbc-time-header-gutter {\n    border-right: 1px solid ", ";\n  }\n  & .rbc-timeslot-group > .rbc-time-slot:nth-child(", ") {\n    border-top: 1px ", " solid !important;\n  }\n  & .rbc-day-slot .rbc-time-slot {\n    border-top: 1px ", " solid !important;\n  }\n  & .rbc-day-slot .rbc-event,\n  .rbc-day-slot .rbc-background-event {\n    min-height: 15px !important;\n  }\n"])), function (props) { return props.height; }, COLORS.gray6, COLORS.gray6, COLORS.gray8, COLORS.gray8, COLORS.gray8, COLORS.gray6, function (props) { return (props.step === 30 ? '2n' : '4n'); }, COLORS.gray6, COLORS.gray7);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;
